import React from "react";
import { Nav, NavItem, NavLink, Container } from "reactstrap";
import Link from "next/link";

type TabState = "users" | "clients" | "sso";

export default function GlobalAuthHeader(props: {
  active: TabState;
}): JSX.Element {
  return (
    <div className="nav-tabs bg-light mb-4">
      <Container style={{ marginBottom: -1 }}>
        <Title />
        <Nav tabs>
          <Tab
            title="Users"
            active={props.active === "users"}
            subPath="/users"
          />
          <Tab
            title="Clients"
            active={props.active === "clients"}
            subPath="/clients"
          />
          <Tab title="SSO" active={props.active === "sso"} subPath="/sso" />
        </Nav>
      </Container>
    </div>
  );
}

function Title() {
  return <h1 className="py-4">Global Auth</h1>;
}

function Tab(props: { active: boolean; subPath: string; title: string }) {
  return (
    <NavItem>
      <Link href={"/global-auth" + props.subPath} passHref>
        <NavLink active={props.active}>{props.title}</NavLink>
      </Link>
    </NavItem>
  );
}
